import React, { memo } from "react";
import { Tag } from "antd";

import styles from "./styles.module.scss";

interface IFilteredTags {
	onClick: Function;
	tags?: {
		id: number;
		name: string;
		is_selected: boolean;
	}[];
	selectedTags?: string[];
}

const FilteredTags: React.FunctionComponent<IFilteredTags> = ({
	tags,
	selectedTags,
	onClick,
}) => {
	return (
		<div className={styles.container}>
			{tags &&
				tags
					.filter(
						(item) =>
							selectedTags && selectedTags.includes(item.name),
					)
					.map((item, index: number) => {
						return (
							<Tag
								className={styles.tag}
								visible={true}
								key={`selected_tag_${item.name}`}
								closable
								onClose={onClick(item.name)}
							>
								{item.name}
							</Tag>
						);
					})}
		</div>
	);
};

export default memo(FilteredTags);
